'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.load = load;
exports.submitLuckyDraw = submitLuckyDraw;
exports.logShare = logShare;
exports.isLoaded = isLoaded;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/digi/LOAD';
var LOAD_SUCCESS = 'redux-frontend/digi/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/digi/LOAD_FAIL';

var SUBMIT = 'redux-frontend/digi/SUBMIT';
var LOG_SHARE = 'redux-frontend/digi/LOG_SHARE';
// const SUBMIT_SUCCESS = 'redux-frontend/digi/SUBMIT_SUCCESS';
// const SUBMIT_FAIL = 'redux-frontend/digi/SUBMIT_FAIL';

var initialState = {
  loading: false,
  loaded: false,
  trips: [],
  inspirations: [],
  localExperts: [],
  reviews: [],
  error: false,
  luckyDrawSubmitted: false,
  luckyDrawSubmitting: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        inspirations: action.result.inspiration_layouts,
        trips: action.result.featured_trips,
        localExperts: action.result.featured_local_experts,
        reviews: action.result.featured_reviews
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        error: true
      });
    case SUBMIT:
      return {
        luckyDrawSubmitted: true
        // luckyDrawSubmitting: true,
      };
    // case SUBMIT_SUCCESS:
    //   return {
    //     luckyDrawSubmitted: true,
    //     luckyDrawSubmitting: false,
    //   };
    // case SUBMIT_FAIL:
    //   return {
    //     luckyDrawSubmitting: false,
    //   };
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, SUBMIT, function (action) {
  return { name: 'Submit Lucky Draw', category: 'Digi', form: action.data };
}), (0, _defineProperty3.default)(_analytics, LOG_SHARE, function (action) {
  return { name: 'Share Lucky Draw', category: 'Digi', form: action.data };
}), _analytics);

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/info/digi');
    }
  };
}

function submitLuckyDraw(data) {
  return {
    type: SUBMIT,
    data: data
  };
}

function logShare() {
  return {
    type: LOG_SHARE
  };
}

function isLoaded(globalState) {
  return globalState.digi && globalState.digi.loaded;
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/digi.js
// module id = 323
// module chunks = 47